<template>
  <div>
    <div class="row">
      <PreDebug class="col" title="sessions">{{ sessions }}</PreDebug>
      <PreDebug class="col" title="currentSession">{{
        currentSession
      }}</PreDebug>
      <PreDebug class="col" title="sessionId">{{ sessionId }}</PreDebug>
    </div>

    <table
      class="table table-striped table-hover mb-3"
      :class="{ 'bg-danger bg-opacity-25': errors }"
    >
      <thead>
        <tr>
          <th class="text-small">Sessions prévues</th>
          <th class="text-small">Places disponibles</th>
        </tr>
      </thead>
      <tbody class="table-group-divider">
        <tr v-if="sessions.length == 0 && formationId === null">
          <td colspan="3" class="text-center">
            <p class="alert alert-info">
              Veuillez selectionner une formation ci-dessus
            </p>
          </td>
        </tr>
        <tr v-if="sessions.length == 0 && !isLoading && formationId !== null">
          <td colspan="3" class="text-center">
            <p class="alert alert-warning">Pas de sessions prévues</p>
          </td>
        </tr>
        <tr v-if="isLoading">
          <td colspan="3" class="text-center p-3">
            <div class="spinner-border text-info" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </td>
        </tr>

        <tr
          v-for="(session, $index) in sessions"
          :key="$index"
          :class="{ 'table-success fw-bold': currentSession == session.id }"
          @click="updateCurrentSession(session.id)"
        >
          <td>
            <input
              type="radio"
              :id="`formation_session-${$index}`"
              name="currentSession"
              :value="session.id"
              v-model="currentSession"
              @change="updateCurrentSession(session.id)"
              class="visually-hidden"
            />

            <label
              class="form-check-label ms-2"
              style="cursor: pointer"
              :for="`formation_session-${$index}`"
            >
              {{ session?.title }}
            </label>
          </td>
          <td>
            {{
              availableParticipants(
                session?.reservations_count,
                session?.max_students
              )
            }}
          </td>
        </tr>
      </tbody>
    </table>
    <div class="row my-5">
      <PreDebug class="col-sm-6" title="sessionId">{{ sessionId }}</PreDebug>
      <PreDebug class="col-sm-6" title="currentSession">{{
        currentSession
      }}</PreDebug>
    </div>

    <!-- <div v-if="errors" class="text-danger mb-3">
      {{ errors[0] || "" }}
    </div> -->

    <!-- <div class="list-group">
      <div
        class="
          list-group-item list-group-item-action
          w-100
          d-flex
          fw-bold
          justify-content-between
        "
      >
        <div>Session</div>
        <div>Places disponibles</div>
      </div>

      <div
        class="list-group-item w-100 d-flex justify-content-between"
        v-if="sessions.length == 0 && !isLoading"
      >
        <p class="alert alert-warning">Pas de sessions prévues</p>
      </div>

      <div
        class="list-group-item w-100 d-flex justify-content-between"
        v-if="isLoading"
      >
        <div class="spinner-border text-info" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <div
        class="list-group-item w-100 d-flex justify-content-between"
        v-for="(session, $index) in sessions"
        :key="$index"
        :class="{ 'fw-bold': currentSession == session.id }"
      >
        <div>
          <input
            type="radio"
            :id="`formation_session-${$index}`"
            name="currentSession"
            :value="session.id"
            v-model="currentSession"
            @change="updateCurrentSession"
          />

          <label
            class="form-check-label ms-2"
            style="cursor: pointer"
            :for="`formation_session-${$index}`"
          >
            {{ session?.title }}
          </label>
        </div>

        <div class="ms-auto">
          {{
            availableParticipants(
              session?.reservations_count,
              session?.max_students
            )
          }}
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import PreDebug from "@/Components/PreDebug.vue";

export default {
  emits: ["update"],

  components: {
    PreDebug,
  },

  props: {
    sessions: {
      type: [Array, Object],
      default() {
        return [];
      },
    },

    isLoading: {
      type: Boolean,
      default: false,
    },

    errors: {
      type: [String, Array],
      required: false,
      default() {
        return "";
      },
    },

    sessionId: {
      type: [Number, String, Object],
      default() {
        return "";
      },
    },
    formationId: {
      type: [Number, String, Object],
      default() {
        return null;
      },
    },
  },

  data() {
    return {
      currentSession: null,
    };
  },

  mounted() {
    console.log("SessionsList mounted");
  },

  unmounted() {
    this.currentSession = null;
  },

  watch: {
    sessionId: {
      handler() {
        this.currentSession = this.sessionId;
      },
    },
  },
  // computed: {
  //   sessionsList() {
  //     if (this.sessions) {
  //       return this.sessions.map((session) => session?.id);
  //     }
  //   },
  // },

  methods: {
    updateCurrentSession(value) {
      if (this.isLoading == false) {
        this.currentSession = value;
        this.$emit("update", this.currentSession);
      }
    },

    availableParticipants(reservations_count = 0, max_count = 12) {
      let total = parseInt(max_count, 10) - parseInt(reservations_count, 10);
      if (total <= 0) {
        return "Aucune Place";
      }
      return total == 1 ? "1 place" : total + " places";
    },
  },
};
</script>

<style>
</style>